import { IApplicationBodyReq, IBasicInfoProperty, ITransformBody } from '../../../components/FormContainers/applicationLocation/Types';

/** Converts a flat object into a nested object grouped by the arrayOfKeys array. 
 * example: 
 * { a: 1, b: 2, c: 3 }  into the { key1: { a: 1, b: 2 }, key2: { c: 3 } } 
 **/
export const groupFlatObject = (initialObject: IBasicInfoProperty | any,
  arrayOfKeys: ITransformBody | any) => {
  const result = Object.keys(initialObject).reduce((acc: any, key: any) => {
    const obj: string | undefined = Object.keys(arrayOfKeys).
      find((objKey) => arrayOfKeys[objKey]?.includes(key));
    if (obj) {
      acc[obj] = acc[obj] || {};
      acc[obj][key] = initialObject[key];
      return acc;
    }
  }, {});

  return result;
};

export const convertJsonBodyToFormData = (body: IApplicationBodyReq | any) => {

  const formData = new FormData();
  body?.media_info?.fileThumbnail.filter(Boolean).length > 0 && typeof body?.media_info?.fileThumbnail[0] !== 'string' &&
    formData.append('file',
      new Blob(body?.media_info?.fileThumbnail, {
        type: body?.media_info?.fileThumbnail[0].type
      }),
      encodeURI(body?.media_info?.fileThumbnail[0].name));
  if (Array.isArray(body?.media_info?.otherMedia) && body?.media_info?.otherMedia.length > 0) {
    body?.media_info?.otherMedia.map((x: File) => {
      if (typeof x !== 'string') {
        formData.append('media',
          new Blob([x], {
            type: x.type
          }),
          encodeURI(x.name));
      }
    });
  }
  if (Array.isArray(body?.doc_info?.attachments) && body?.doc_info?.attachments.length > 0) {
    body?.doc_info?.attachments.map((x: File) => {
      if (typeof x !== 'string') {
        formData.append('attachments',
          new Blob([x], {
            type: x.type
          }),
          encodeURI(x.name));
      }
    });
  }

  formData.append('form', JSON.stringify(body));
  return formData;
};

const getPreviousStringFiles = (input: any) => {
  const arrString = input?.map((file: File | string) => {
    if (typeof file === 'string') {
      return file;
    }
  }).filter((x: any) => x);
  return arrString;
};

export const filterPreviousStringFiles = (values: IBasicInfoProperty) => {
  values['otherMedia'] = values?.otherMedia && getPreviousStringFiles(values.otherMedia);
  values['attachments'] = values?.attachments && getPreviousStringFiles(values.attachments);
  values['fileThumbnail'] = values?.fileThumbnail && getPreviousStringFiles(values.fileThumbnail);

  return values;
};

export const transformFormBodyToFormData = (values: any): FormData => {
  // TODO: this array of keys assignment should be dynamic. This can happen if we match the BE response keys to FE form fields initialValues. It would be really helpfull for future forms. 
  const basic_info: string[] = ['title_property', 'category_lvl1', 'info_property', 'info_property_en', 'category_loc', 'category_lvl3', 'amea', 'heavy_vehicles', 'limitations', 'limitations_en', 'keywords', 'keywords_gr', 'licensing', 'licensing_en'];
  const address_info: string[] = ['marker', 'region', 'addressPostalCode', 'addressName', 'addressNumber', 'lat', 'lon'];
  const media_info: string[] = ['fileThumbnail', 'otherMedia'];
  const resp_user_info: string[] = ['name', 'surname', 'phone', 'email', 'website'];
  const doc_info: string[] = ['attachments', 'termsAndConditions', 'applicationId', 'preinserted'];
  const arrayOfKeys: ITransformBody = {
    basic_info,
    address_info,
    media_info,
    resp_user_info,
    doc_info
  };
  delete values?.location;
  
  const final_body = groupFlatObject(values, arrayOfKeys);

  return convertJsonBodyToFormData(final_body);
};

const filterFilesArray = (input: any): File[] => {
  return input.filter((item: File | string) => item instanceof File) as File[];
};

export const filterPreviousFilesFromBody = (values: IBasicInfoProperty) => {
  values['otherMedia'] = values?.otherMedia && filterFilesArray(values.otherMedia);
  values['attachments'] = values?.attachments && filterFilesArray(values.attachments);
  values['fileThumbnail'] = values?.fileThumbnail && filterFilesArray(values.fileThumbnail);

  return values;
};